module.exports = __webpack_public_path__ + "0d5fdcaed8dbdd3f0f9204989a191d38.svg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/Facebook_20x20.svg
// module id = 285
// module chunks = 0